'use strict';

/* Services */
import historyService from '../../services/history/history.service';

/* Views */
import history from './view/history.component';

/* Module */
export default angular.module('conduu.ap.history', [historyService, history])
  .name;



// WEBPACK FOOTER //
// ./client/~ap/app/history/index.js